import request from '@/services/request';

export const actions = {
  async fetchIntegrations(_, entityId) {
    const { data, error } = await request.get(`/org/${entityId}/gateway-integration`);
    if (error) {
      throw new Error(data);
    }
    return data;
  },
  async updateIntegration(_, { updates, entityId, integrationId }) {
    const { data, error } = await request.put(`/org/${entityId}/gateway-integration/${integrationId}`, updates);
    if (error) {
      throw new Error(data);
    }
    return data;
  }
};
